import NavigationBarControl from '../../../lib/ui/NavigationBarControl'

export default class Offline {
  constructor (element) {
    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Externe opslag niet bereikbaar'
    })

    let div = document.createElement('div')
    div.className = 'viewport'

    let p = document.createElement('p')
    p.innerHTML = 'Helaas kan PRIM de externe opslag niet bereiken en uw gegevens niet ophalen. Zonder externe opslag kunt u niet gebruik maken van deze applicatie. Controleer uw verbinding en probeer opnieuw.'

    let buttonReload = document.createElement('button')
    buttonReload.innerHTML = 'Herstarten en opnieuw proberen'
    buttonReload.onclick = () => {
      location.replace('/')
    }

    div.appendChild(p)
    div.appendChild(buttonReload)
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/start/action/Offline.js